export default __webpack_public_path__ + "static/media/Homepage-packages-image-size-370_370-Narmada-Parikrama.32e4b1a9.png";